import React from "react";
import { Link } from "react-router-dom";

const ScoringHelp = () => {
  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <div className="mb-6">
        <Link to="/help" className="text-deep-red hover:text-bright-red">
          &larr; Back to Help Center
        </Link>
      </div>
      <h1 className="text-3xl font-bold text-dark-grey mb-6">Scoring Help</h1>
      <div className="space-y-6">
        <section>
          <h2 className="text-2xl font-semibold text-dark-grey mb-4">How Scoring Works</h2>
          <p className="text-medium-grey">
            Scoring in DayShift Fantasy MMA is based on fighter performance in actual UFC events. 
            You earn points based on how your selected fighters perform in their matches.
          </p>
        </section>
        
        <section>
          <h2 className="text-2xl font-semibold text-dark-grey mb-4">Point System</h2>
          <p className="text-medium-grey mb-4">
            Points are awarded for the following outcomes:
          </p>
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white border border-gray-300">
              <thead>
                <tr className="bg-gray-100">
                  <th className="py-2 px-4 border-b">Outcome</th>
                  <th className="py-2 px-4 border-b">Points</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="py-2 px-4 border-b">Victory</td>
                  <td className="py-2 px-4 border-b">10 points</td>
                </tr>
                <tr>
                  <td className="py-2 px-4 border-b">KO/TKO Bonus</td>
                  <td className="py-2 px-4 border-b">+5 points</td>
                </tr>
                <tr>
                  <td className="py-2 px-4 border-b">Submission Bonus</td>
                  <td className="py-2 px-4 border-b">+5 points</td>
                </tr>
                <tr>
                  <td className="py-2 px-4 border-b">First Round Finish Bonus</td>
                  <td className="py-2 px-4 border-b">+3 points</td>
                </tr>
                <tr>
                  <td className="py-2 px-4 border-b">Decision Victory</td>
                  <td className="py-2 px-4 border-b">+2 points</td>
                </tr>
                <tr>
                  <td className="py-2 px-4 border-b">Significant Strikes (per 25)</td>
                  <td className="py-2 px-4 border-b">+1 point</td>
                </tr>
                <tr>
                  <td className="py-2 px-4 border-b">Takedowns (per 2)</td>
                  <td className="py-2 px-4 border-b">+1 point</td>
                </tr>
                <tr>
                  <td className="py-2 px-4 border-b">Lock of the Night Win</td>
                  <td className="py-2 px-4 border-b">+10 points</td>
                </tr>
                <tr>
                  <td className="py-2 px-4 border-b">Lock of the Night Loss</td>
                  <td className="py-2 px-4 border-b">-5 points</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
        
        <section>
          <h2 className="text-2xl font-semibold text-dark-grey mb-4">Tie-Breakers</h2>
          <p className="text-medium-grey">
            In case of a tie in league standings, the following tie-breakers are applied in order:
          </p>
          <ol className="list-decimal pl-5 text-medium-grey space-y-2">
            <li>Total number of fighters who won</li>
            <li>Total number of fighters who won by KO/TKO or submission</li>
            <li>Total number of first-round finishes</li>
            <li>Head-to-head record (if applicable)</li>
          </ol>
        </section>
      </div>
    </div>
  );
};

export default ScoringHelp;
